export const baseUrl = import.meta.env.MODE === 'development' ? '/api' : '/api'
